import React, { useContext, useEffect, useState } from 'react'
import { AboutJob } from './AboutJob'
import useTranslation from '../hooks/useTranslation'
import { RedirectLinkButton } from './RedirectLinkButton'
import { CarouselComponent } from '../components/CarouselComponent'
import useWindowSize from '../hooks/useWindowSize'
import { trackEvent } from '../analytics'
import { seekersAnalayticOptions } from '../utils/functions'
import { SharedContext } from '../context/SharedContext'

export const SponsoredJobsCarousel = ({ data, setShowSponsoredJobs }) => {
  const translation = useTranslation()
  const [sponsoredData, setSponsoredData] = useState([])
  const windowSize = useWindowSize()
  const { utmParams, loginDetails, location } = useContext(SharedContext)

  useEffect(() => {
    let temp = data?.filter((item) => {
      return !!item?.job_role && !!item?.translated_content?.title
    })
    setSponsoredData([...temp])
  }, [data])

  return (
    sponsoredData?.length > 0 && (
      <div className="bg-[#FFF1CC] py-[12px] sm:py-[28px]" id="sponsored_jobs_carousel_container">
        <div className="flex items-center justify-between px-[12px]" id="sj_header_div">
          <h1
            className="select-none font-noto-sans text-lg font-bold leading-[28.8px] sm:text-[24px] sm:leading-[38.4px]"
            id="sj_text"
          >
            {translation.sponsoredJobs}
          </h1>
          <div id="sj_see_all_button" className="select-none">
            <RedirectLinkButton
              title={translation.seeAll}
              onClick={() => {
                trackEvent({
                  name: 'tap_view_all_sponsored_jobs',
                  searchParams: {
                    ...utmParams
                  },
                  options: seekersAnalayticOptions(
                    window,
                    loginDetails,
                    location,
                    'tap',
                    'listings_page'
                  ),
                  isSeeker: true
                })
                setShowSponsoredJobs(true)
              }}
              className="text-[14px]"
              imageDetails={{ width: 16, height: 16 }}
              imageClass="ml-[4px]"
            />
          </div>
        </div>
        <CarouselComponent
          numberOfCarousels={sponsoredData?.slice(0, 5)?.length}
          time={2000}
          dotsClassName="mt-[4px]"
          isArrowControl={windowSize > 1100}
          widthOfCard={320}
          containerClassname="px-sm"
          fullWidth={windowSize < 640 ? true : false}
        >
          {sponsoredData?.slice(0, 5)?.map((item, index) => (
            <div
              style={{ width: '100%', overflow: 'hidden' }}
              className="px-sm sm:w-[320px] sm:px-[0px] sm:pr-sm"
              key={index}
            >
              <AboutJob
                jobDetails={item}
                showBottomDiv={false}
                showQualificationOnTop={true}
                key={index}
                showKebabMenu={false}
                sponsoredJobs={true}
                {...{
                  source: 'sponsored jobs'
                }}
              />
            </div>
          ))}
        </CarouselComponent>
        <div className="pb-[4px]"></div>
      </div>
    )
  )
}
